'use client';

import { useEffect } from 'react';

import { usePathname, useRouter, useSearchParams } from 'next/navigation';

import { useToast } from '@/components/ui/Toasts/use-toast';

import { Toaster as SileoToaster } from 'sileo';

export function Toaster() {
  const { toast } = useToast();
  const searchParams = useSearchParams();
  const pathname = usePathname();
  const router = useRouter();

  useEffect(() => {
    const status = searchParams.get('status');
    const status_description = searchParams.get('status_description');
    const error = searchParams.get('error');
    const error_description = searchParams.get('error_description');

    if (error || status) {
      if (error) {
        toast.error(error || 'Hmm... Something went wrong.', {
          description: error_description ?? undefined
        });
      } else if (status) {
        toast.success(status || 'Alright!', {
          description: status_description ?? undefined
        });
      }

      const newSearchParams = new URLSearchParams(searchParams.toString());
      const paramsToRemove = [
        'error',
        'status',
        'status_description',
        'error_description'
      ];
      paramsToRemove.forEach((param) => newSearchParams.delete(param));
      const redirectPath = `${pathname}${newSearchParams.toString() ? `?${newSearchParams.toString()}` : ''}`;
      router.replace(redirectPath, { scroll: false });
    }
  }, [searchParams, toast, pathname, router]);

  return (
    <SileoToaster
      position='top-right'
      theme='system'
    />
  );
}
